import styled from 'styled-components';

export const ActionsWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: ${(props) =>
    props.placeEnd ? 'flex-end' : 'space-between'};
  margin-bottom: 20px;

  .ant-breadcrumb-link a {
    &:hover {
      color: #f49b1a;
    }
  }
`;
